module.exports = __webpack_public_path__ + "img/21.acbc8119.png";